module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/contact_satellite.5269b6ce.png";